import { HttpClient } from '@angular/common/http';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  viewChild
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';

import { VocalistGender } from 'src/app/core/api/models';
import { VoiceMessagesService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { AppConfigService } from 'src/app/core/services/config.service';
import { BaseFormPageComponent } from 'src/app/pages/shared/base/components/base-form-page.component';
import { CreateVocalistFileCommand } from './../../../../core/api/models/create-vocalist-file-command';
import { UtilService } from './../../../../core/services/util.service';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { AudioControllerModule } from "../../../../shared/components/audio-controller/audio-controller.module";


@Component({
    selector: 'app-text-to-voice-convertor',
    templateUrl: './text-to-voice-convertor.component.html',
    styleUrls: ['./text-to-voice-convertor.component.scss'],
    imports: [BaseFormModule, AudioControllerModule]
})
export class TextToVoiceConvertorComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region properties
  readonly voiceTextTextArea = viewChild<ElementRef<HTMLElement>>('voiceTextTextArea');

  @Input() model: CreateVocalistFileCommand = {};
  @Input() agentVoiceMessageId: number;
  @Input() formId: string = 'textToVoiceConvertorForm';
  gender: VocalistGender;

  get VocalistGender() {
    return VocalistGender;
  }
  apiUrl: string = AppConfigService.config.apiUrl + '/';
  voiceFileSrc: string = '';
  voiceText: string;
  isSuccessConvertTextToVoiceOperation: boolean = true;
  palyAgain: boolean = false;

  textVoiceElementFocusEvent;

  @Output('agentVoiceMessageId') output_agentVoiceMessageId =
    new EventEmitter<number>();
  @Output('blob') output_blob = new EventEmitter<any>();
  @Output('filePatch') output_filePatch = new EventEmitter<string>();
  @Output('form') output_form = new EventEmitter<FormGroup>();

  //#endregion

  constructor(
    protected currentService: VoiceMessagesService,
    public http: HttpClient
  ) {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
      this.detectChangeForm();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.voiceMessages
      );
    }
  }

  detectChangeForm() {
    try {
      this.form.valueChanges
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((event) => {
          this.emitForm();
        });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.voiceMessages
      );
    }
  }

  initForm(): void {
    this.form = new FormGroup({
      gender: new FormControl('', Validators.required),
      voiceText: new FormControl('', Validators.required),
    });
  }

  //#region api

  voiceMessagesUploadVocalistFileApi(model: CreateVocalistFileCommand) {
    this.loading = true;
    this.unSubs();

    model.agentVoiceMessageId = this.agentVoiceMessageId;

    this.currentService
      .voiceMessagesUploadVocalistFile({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(
        (res) => {
          try {
            this.isSuccessConvertTextToVoiceOperation = true;
            this.model.agentVoiceMessageId = res?.data?.agentVoiceMessageId;
            this.output_agentVoiceMessageId.emit(
              res?.data?.agentVoiceMessageId
            );
            this.output_filePatch.emit(res?.data?.path);
            this.createVoiceFile(res?.data?.path);
            this.onPlayAgain();
          } catch (error) {
            this.loggerService.logError(
              this.tagName,
              error,
              EventTypes.voiceMessages
            );
          }
        },
        (err) => {
          this.isSuccessConvertTextToVoiceOperation = false;
        }
      );
  }

  //#endregion

  createVoiceFile(path: string) {
    this.voiceFileSrc = this.apiUrl + path;
  }

  clearText() {
    try {
      this.voiceText = '';
      this.model.voiceText = '';
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.voiceMessages
      );
    }
  }

  onAddTanvinLetterToVoiceText(tanvinLetter: string) {
    try {
      const textAreaElement =
        this.voiceTextTextArea().nativeElement.querySelector('textarea');
      const textAreaValue = textAreaElement.value;
      // GET CURRENT CURSOR POSITION
      const oldCursorPos = textAreaElement.selectionStart;
      // GET TEXT BEFORE CURSOR POSITION
      let output = textAreaValue.substring(0, oldCursorPos);
      // INSERT TANVIN LETTER IN BETWEEN
      output += tanvinLetter.trim();
      // GET TEXT AFTER CURSOR POSITION
      output += textAreaValue.substring(oldCursorPos, textAreaValue.length);

      this.voiceText = output;

      const clearTimeout = setTimeout(() => {
        textAreaElement.selectionStart = oldCursorPos;
        textAreaElement.selectionEnd = oldCursorPos;
        textAreaElement.focus();
        clearInterval(clearTimeout);
      }, 5);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.voiceMessages
      );
    }
  }

  onConvertTextToVoice() {
    try {
      if (this.loading) return;
      if (!this.isValidForm(this.form, this.tagName)) return;
      if (
        this.voiceText == this.model.voiceText &&
        this.gender == this.model.gender &&
        this.isSuccessConvertTextToVoiceOperation
      )
        this.onPlayAgain();
      else {
        this.model.voiceText = this.voiceText;
        this.model.gender = this.gender;
        this.voiceMessagesUploadVocalistFileApi(this.model);
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.voiceMessages
      );
    }
  }

  onDownload() {
    try {
      UtilService.downloadFile(this.voiceFileSrc, false);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.voiceMessages
      );
    }
  }

  emitForm() {
    this.output_form.emit(this.form);
  }

  onPlayAgain() {
    this.palyAgain = !this.palyAgain;
  }
}
